/**
 * @param {object} address
 * @param {string} [address.line1]
 * @param {string} [address.line2]
 * @param {string} [address.line3]
 * @param {string} [address.city]
 * @param {string} [address.state]
 * @param {string} [address.postalCode]
 * @param {string} [address.countryCode]
 * @returns {string}
 */
export function formatAddress(address) {
  if (!address) return '';

  const {
    addressLine1 = '',
    addressLine2 = '',
    line1 = '',
    line2 = '',
    line3 = '',
    city = '',
    state = '',
    postalCode = '',
    countryCode = '',
  } = address;

  let streetAddress = line1 !== '' ? line1 : addressLine1;
  if (line2 || addressLine2) streetAddress += ` ${line2 !== '' ? line2 : addressLine2}`;
  if (line3) streetAddress += ` ${line3}`;

  let locationPart = '';
  if (city) locationPart += city;
  if (state) locationPart += city ? `, ${state}` : state;
  if (postalCode) locationPart += ` ${postalCode}`;
  if (countryCode && !locationPart.includes(countryCode)) {
    locationPart += locationPart ? `, ${countryCode}` : countryCode;
  }
  const parts = [streetAddress, locationPart].filter((part) => part && part.trim());

  return parts.join(', ');
}
